import { useMutation, useQuery } from '@tanstack/react-query'

import {
  getReconsentOtpWeb,
  sendConsentOtp,
  shareReconsentGlobalOtpVerificationLink,
  shareReconsentOtpVerificationLink,
  verifyConsentOtp,
  verifyConsentOtpWeb,
} from '../../functions'
import { shareReconsentOtpVerificationLinkRequest } from '../../types'

function useSendConsentOtp() {
  return useMutation(sendConsentOtp, {
    onSuccess: (data) => {
      console.log('sendConsentOtpSuccess', data)
    },
    onError: (data) => {
      console.warn('sendConsentOtpError', data)
    },
  })
}

function useVerifyConsentOtp() {
  return useMutation(verifyConsentOtp, {
    onSuccess: (data) => {
      console.log('verifyConsentOtpSuccess', data)
    },
    onError: (data) => {
      console.warn('verifyConsentOtpError', data)
    },
  })
}

function useShareReconsentOtpVerificationLink(
  suppliedData: shareReconsentOtpVerificationLinkRequest
) {
  return useQuery(
    ['shareReconsentOtpVerificationLink'],
    () => shareReconsentOtpVerificationLink(suppliedData),
    {
      enabled: false,
      staleTime: 0,
      cacheTime: 0,
      refetchInterval: 0,
      onSuccess: suppliedData?.onSuccess,
    }
  )
}

function useShareReconsentGlobalOtpVerificationLink(
  suppliedData: shareReconsentOtpVerificationLinkRequest
) {
  return useQuery(
    ['shareReconsentGlobalOtpVerificationLink'],
    () => shareReconsentGlobalOtpVerificationLink(suppliedData),
    {
      enabled: false,
      staleTime: 0,
      cacheTime: 0,
      refetchInterval: 0,
      onSuccess: suppliedData?.onSuccess,
    }
  )
}

function useGetReconsentOtpWeb() {
  return useMutation(getReconsentOtpWeb)
}

function useVerifyConsentOtpWeb() {
  return useMutation(verifyConsentOtpWeb)
}

export {
  useGetReconsentOtpWeb,
  useSendConsentOtp,
  useShareReconsentGlobalOtpVerificationLink,
  useShareReconsentOtpVerificationLink,
  useVerifyConsentOtp,
  useVerifyConsentOtpWeb,
}
